import { __rest } from 'tslib';
import React from 'react';
import { Popper, autocompleteClasses, Autocomplete, InputAdornment } from '@mui/material';
import { Plus, Search } from '@piiqtechnologies/svg-icons';
import { styled } from '@mui/material/styles';
import { PeekTextField } from './PeekTextField.js';
import { PeekPaper } from './PeekPaper.js';
import { PeekTypography } from './PeekTypography.js';
import { PeekLoader } from './loader/PeekLoader.js';
import './loader/PeekScreenLoader.js';
import { PeekStack } from './PeekStack.js';
import { PeekButton } from './PeekButton.js';
import { PeekListItem } from './PeekListItem.js';

const StyledAutocompletePopper = styled(Popper)(({ theme }) => ({
    paddingTop: theme.spacing(0.5),
    zIndex: "9999 !important",
    [`& .${autocompleteClasses.listbox}`]: {
        [`& .${autocompleteClasses.option}`]: {
            "&.Mui-focused": {
                //@ts-ignore
                backgroundColor: theme.palette.common.opacityTeal,
            },
            '&[aria-selected="true"] ': {
                backgroundColor: "transparent",
                "&.Mui-focused": {
                    //@ts-ignore
                    backgroundColor: theme.palette.common.opacityTeal,
                },
            },
        },
    },
}));
const PopperComponent = (props) => {
    const other = __rest(props, ["placement"]);
    return React.createElement(StyledAutocompletePopper, Object.assign({}, other, { placement: "bottom-start" }));
};
const StyledAutocompletePaper = styled(PeekPaper)(({ theme }) => ({
    border: "none",
    borderRadius: 3.2,
    "& .MuiAutocomplete-noOptions": { color: theme.palette.text.primary },
    "& .MuiAutocomplete-listbox": {
        maxHeight: 230,
    },
}));
const AutocompletePaperComponent = (_a) => {
    var { children, multiple, onSelectAll, onClearAll } = _a, props = __rest(_a, ["children", "multiple", "onSelectAll", "onClearAll"]);
    return (React.createElement(StyledAutocompletePaper, Object.assign({}, props),
        React.createElement(PeekStack, { direction: "column" },
            multiple && (React.createElement(PeekStack, { direction: "row", sx: { px: 0.5 }, justifyContent: "space-between" },
                React.createElement(PeekButton, { color: "secondary", onClick: onSelectAll },
                    React.createElement(PeekTypography, { variant: "body2" }, "Select all")),
                React.createElement(PeekButton, { color: "secondary", onClick: onClearAll },
                    React.createElement(PeekTypography, { variant: "body2" }, "Clear all")))),
            children)));
};
//@ts-ignore
const PeekAutocomplete = (_a) => {
    var { onSelectAll, onClearAll, addNewLabel, addNewLabelSize = 10, onAddNew } = _a, props = __rest(_a, ["onSelectAll", "onClearAll", "addNewLabel", "addNewLabelSize", "onAddNew"]);
    return (React.createElement(Autocomplete, Object.assign({ loadingText: React.createElement(PeekTypography, { variant: "body1", textAlign: "center" },
            React.createElement(PeekLoader, null)), PopperComponent: PopperComponent, PaperComponent: (paperProps) => (React.createElement(AutocompletePaperComponent, Object.assign({}, paperProps, { elevation: 2, onSelectAll: onSelectAll, onClearAll: onClearAll, multiple: props.multiple }))), renderOption: (optionsProps, option, { selected }) => (React.createElement(PeekListItem, Object.assign({}, optionsProps, { selected: selected }), (!!props.getOptionLabel(option) && props.getOptionLabel(option)) ||
            (addNewLabel && (React.createElement(PeekButton, { fullWidth: true, onClick: (event) => {
                    event.stopPropagation();
                    onAddNew && onAddNew();
                }, startIcon: React.createElement(Plus, { height: 12, width: 12 }), sx: { ":hover": { bgcolor: "transparent" }, height: addNewLabelSize, justifyContent: "flex-start" } },
                React.createElement(PeekTypography, { variant: "body1", fontWeight: "fontWeightBold" }, addNewLabel)))))), renderInput: (params) => (React.createElement(PeekTextField, Object.assign({ placeholder: props.placeholder || "Search" }, params, { InputProps: Object.assign(Object.assign({}, params.InputProps), { sx: { "&.MuiOutlinedInput-root": { py: 0 } }, startAdornment: (React.createElement(InputAdornment, { position: "start" },
                    React.createElement(Search, null))) }) }))) }, props)));
};

export { PeekAutocomplete, PeekAutocomplete as default };
